<!-- PageWatcher.vue -->

<template>
</template>

<script lang="ts" setup>
	// v3: useContent() is gone with documentDriven. The current doc is published
	// by pages/[...slug].vue into useCurrentDoc(); we only need it here to
	// re-observe headings whenever the rendered document changes.
	const page = useCurrentDoc();

	// Fetch current route
	const route = useRoute();
	const emit = defineEmits(['updateActiveTocId']);

	// Watch for document changes to re-observe headings
	watch(
		page,
		() => {
			if(observer != null) {
				headings.value?.forEach((heading) => observer?.unobserve(heading)); // Clean up old observers
			}
			observeHeadings(); // Re-observe new headings
		}
	);

	// Reactive reference for headings
	const headings = ref<Element[]>([]);

	// Intersection observer setup
	const activeTocId = ref<string>('');

	// Observer options
	const observerOptions = {
		root: null,
		rootMargin: '0px',
		threshold: 0.1, // Adjust for earlier or later triggers
	};

	let observer: IntersectionObserver | null = null;
	const observeHeadings = () => {
		headings.value = Array.from(document.querySelectorAll('h2, h3')).filter(
			(node): node is Element => node instanceof Element
		);

		if (observer != null) {
			headings.value.forEach((heading) => observer?.observe(heading));
		}
	};

	if (typeof IntersectionObserver !== 'undefined') {
		observer = new IntersectionObserver((entries) => {
			const visibleEntries = entries.filter((entry) => entry.isIntersecting);
			console.log('visibleEntries.length ToC:', visibleEntries.length);
			if (visibleEntries.length > 0) {
				const firstVisible = visibleEntries.sort(
					(a, b) => a.target.getBoundingClientRect().top - b.target.getBoundingClientRect().top
				)[0];
				activeTocId.value = firstVisible.target.id;
				console.log('Active ToC:', activeTocId.value);
				emit('updateActiveTocId', activeTocId.value);
				console.log('Event emitted: updateActiveTocId', activeTocId.value);
			}
		}, observerOptions);

		// Function to observe headings
	}

	// Scroll and Intersection Observer setup
	onMounted(() => {
		// Ensure IntersectionObserver is available (for client-side only)
		if (typeof IntersectionObserver !== 'undefined') {
			observeHeadings(); // Observe headings initially
		} else {
			console.error('IntersectionObserver is not supported in this environment');
		}
	});

	// Cleanup observer on component unmount
	onBeforeUnmount(() => {
		if (observer != null) {
			headings.value?.forEach((heading) => observer.unobserve(heading));
		}
	});
</script>

<style></style>
